module.exports = __webpack_public_path__ + "img/car-6.bf16a738.png";